'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseProps = exports.propTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = exports.propTypes = {
  transform: _propTypes2.default.string
};

var parseTransform = function parseTransform(transform) {
  return (0, _glamor.css)({
    transform: transform
  });
};

var parseProps = exports.parseProps = function parseProps(_ref) {
  var transform = _ref.transform,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ['transform', 'className']);

  return _extends({
    className: transform !== undefined ? (0, _classnames2.default)('' + parseTransform(transform), className) : className
  }, props);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbmhhbmNlcnMvdHJhbnNmb3JtLmpzIl0sIm5hbWVzIjpbInByb3BUeXBlcyIsInRyYW5zZm9ybSIsInN0cmluZyIsInBhcnNlVHJhbnNmb3JtIiwicGFyc2VQcm9wcyIsImNsYXNzTmFtZSIsInByb3BzIiwidW5kZWZpbmVkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7OztBQUNBOztBQUNBOzs7Ozs7OztBQUVPLElBQU1BLGdDQUFZO0FBQ3ZCQyxhQUFXLG9CQUFVQztBQURFLENBQWxCOztBQUlQLElBQU1DLGlCQUFpQixTQUFqQkEsY0FBaUIsQ0FBQ0YsU0FBRDtBQUFBLFNBQWUsaUJBQUk7QUFDeENBO0FBRHdDLEdBQUosQ0FBZjtBQUFBLENBQXZCOztBQUlPLElBQU1HLGtDQUFhLFNBQWJBLFVBQWE7QUFBQSxNQUFHSCxTQUFILFFBQUdBLFNBQUg7QUFBQSxNQUFjSSxTQUFkLFFBQWNBLFNBQWQ7QUFBQSxNQUE0QkMsS0FBNUI7O0FBQUE7QUFDeEJELGVBQVdKLGNBQWNNLFNBQWQsR0FBMEIsK0JBQU1KLGVBQWVGLFNBQWYsQ0FBTixFQUFtQ0ksU0FBbkMsQ0FBMUIsR0FBMEVBO0FBRDdELEtBRXJCQyxLQUZxQjtBQUFBLENBQW5CIiwiZmlsZSI6InRyYW5zZm9ybS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcydcbmltcG9ydCB7IGNzcyB9IGZyb20gJ2dsYW1vcidcbmltcG9ydCBjeCBmcm9tICdjbGFzc25hbWVzJ1xuXG5leHBvcnQgY29uc3QgcHJvcFR5cGVzID0ge1xuICB0cmFuc2Zvcm06IFByb3BUeXBlcy5zdHJpbmdcbn1cblxuY29uc3QgcGFyc2VUcmFuc2Zvcm0gPSAodHJhbnNmb3JtKSA9PiBjc3Moe1xuICB0cmFuc2Zvcm1cbn0pXG5cbmV4cG9ydCBjb25zdCBwYXJzZVByb3BzID0gKHsgdHJhbnNmb3JtLCBjbGFzc05hbWUsIC4uLnByb3BzIH0pID0+ICh7XG4gIGNsYXNzTmFtZTogdHJhbnNmb3JtICE9PSB1bmRlZmluZWQgPyBjeChgJHtwYXJzZVRyYW5zZm9ybSh0cmFuc2Zvcm0pfWAsIGNsYXNzTmFtZSkgOiBjbGFzc05hbWUsXG4gIC4uLnByb3BzXG59KVxuIl19


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/enhancers/transform.js
// module id = 1154
// module chunks = 0